import Login from "../../../pages/auth/Login";
import Homepage from "../../../pages/homepage/Homepage";
import Register from "../../../pages/auth/Register";
import ForgetPassword from "../../../pages/auth/ForgetPassword";

const AuthTemplate = () => {
  const authenticated = false;
  const filePath = window.location.pathname;

  return (
    <div>
      {authenticated && <Homepage />}
      {filePath === "/register" ? (
        <Register />
      ) : filePath === "/login" ? (
        <Login />
      ) : (
        <ForgetPassword />
      )}
    </div>
  );
};

export default AuthTemplate;
